export default __webpack_public_path__ + "static/history-20a4c9827e0026ee224fc1067988d6d0.mp4";